// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3MRoU","label":"styles_label__zWgF2"};